// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__3JrJV","cellSelected":"Cell_cellSelected__1W3CR"};